<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted() {
    let that = this
    that.$store.dispatch('auth/autoLogin').then(() => {
      if (that.$route.path == '/login') {
        that.$router.push('/index')
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
}
</style>
